export default "__VITE_ASSET__C2XD_2q$__"